import { ErrorEvent, EventHint } from '@sentry/react';

export const beforeSend = (event: ErrorEvent, hint: EventHint) => {
  console.error(hint.originalException || hint.syntheticException);
  // 检查事件是否匹配特定类型的错误
  if (event.exception && event.exception.values) {
    for (const exc of event.exception.values) {
      // 如果错误信息包含特定字符串，则不发送该事件
      const ignoredMessageArr = [
        'Failed to fetch dynamically imported module',
        '无法删除，知识库与其他机器人有绑定关系',
        'Unable to delete, knowledge base is associated with other robots',
        '削除できません。ナレッジベースは他のロボットと関連しています',
        '無法刪除，知識庫與其他機器人有綁定關係',
        'Invalid regular expression: invalid group specifier name', // 低版本Safari不兼容一些正则表达式，会导致小部件无法在页面上不展示，不要上报这个错误（因为数量太多），再逐步定位解决这个问题。
      ];
      const isIgnoredMessage = ignoredMessageArr.findIndex((item) => (exc.value || '').includes(item)) !== -1;
      if (exc.value && isIgnoredMessage) {
        return null; // 返回null意味着整个事件都会被忽略
      }
    }
  }
  // 返回事件意味着事件会被发送
  return event;
};
